import { getMasterData } from "./api";

const FILTER_CACHE_PREFIX = "rmpmDashboardFilters_";
const FILTER_CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24h — options rarely change within a day
const FAVORITES_CACHE_PREFIX = "rmpmDashboardFavorites_";

const masterDataInFlight = new Map();

const cacheKeyFor = (filterType) => `${FILTER_CACHE_PREFIX}${filterType}`;
export const readCachedMaster = (filterType) => {
    try {
        const raw = localStorage.getItem(cacheKeyFor(filterType));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.timestamp || !parsed.data) return null;
        return {
            data: parsed.data,
            stale: (Date.now() - parsed.timestamp) > FILTER_CACHE_TTL_MS,
        };
    } catch (_) {
        return null;
    }
};

export const writeCachedMaster = (filterType, data) => {
    try {
        localStorage.setItem(
            cacheKeyFor(filterType),
            JSON.stringify({ data, timestamp: Date.now() })
        );
    } catch (_) {
    }
};

const favoritesKeyFor = (filterType, email) => `${FAVORITES_CACHE_PREFIX}${filterType}|${email}`;

export const readFavorites = (filterType, email) => {
    try {
        const raw = localStorage.getItem(favoritesKeyFor(filterType, email));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : null;
    } catch (_) {
        return null;
    }
};

export const writeFavorites = (filterType, email, favKeys) => {
    try {
        localStorage.setItem(
            favoritesKeyFor(filterType, email),
            JSON.stringify(Array.isArray(favKeys) ? favKeys : [])
        );
    } catch (_) {
    }
};
export const fetchMasterDataDedup = (filterType, email) => {
    const key = `${filterType}|${email}`;
    if (masterDataInFlight.has(key)) {
        return masterDataInFlight.get(key);
    }
    const promise = getMasterData(encodeURIComponent(filterType), email)
        .finally(() => {
            masterDataInFlight.delete(key);
        });
    masterDataInFlight.set(key, promise);
    return promise;
};

export const prefetchMaster = (filterType, email) => {
    if (!filterType || !email) return Promise.resolve();
    const cached = readCachedMaster(filterType);
    if (cached && !cached.stale) return Promise.resolve();
    return fetchMasterDataDedup(filterType, email)
        .then((res) => {
            if (res?.filters && typeof res.filters === "object") {
                writeCachedMaster(filterType, res);
            }
        })
        .catch((err) => {
            console.debug(`[filterMasterCache] prefetch failed for ${filterType}:`, err?.message);
        });
};
